import React from 'react'
import * as THREE from 'three'
import Progress from '@/components/progress'
import textImg from './bgd.png'
import smokeImg from './smoke.png'
import styles from './index.module.scss'

export default class Smoke extends React.PureComponent {
  ref = React.createRef()
  smokeParticles = []
  raf = null

  init () {
    const scene = new THREE.Scene();
    const textGeo = new THREE.PlaneGeometry(192, 108, 10, 10);
    const textTexture = new THREE.TextureLoader().load(textImg)
    const textMaterial = new THREE.MeshLambertMaterial({
      color: 0xffffff,
      opacity: .5,
      map: textTexture,
      transparent: true,
      blending: THREE.AdditiveBlending
    })
    const text = new THREE.Mesh(textGeo, textMaterial);
    text.position.z = 300;
    scene.add(text);

    const light = new THREE.DirectionalLight(0xffffff, 0.5);
    light.position.set(-1, 0, 1);
    scene.add(light);

    const smokeTexture = new THREE.TextureLoader().load(smokeImg);
    const smokeMaterial = new THREE.MeshLambertMaterial({
      color: 0xffffff,
      map: smokeTexture,
      transparent: true,
      opacity: .4
    });
    const smokeGeo = new THREE.PlaneGeometry(300, 300);

    for (let p = 0; p < 20; p++) {
      var particle = new THREE.Mesh(smokeGeo, smokeMaterial);
      particle.position.set(Math.random() * 300 - 150, Math.random() * 300 - 150, Math.random() * 450 - 100);
      particle.rotation.z = Math.random() * 200;
      scene.add(particle);
      this.smokeParticles.push(particle);
    }

    const renderer = new THREE.WebGLRenderer({
      canvas: this.ref.current
    });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setClearColor(0x001426, 1);

    const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 1100);
    camera.position.set(0, 0, 400)

    const clock = new THREE.Clock()
    const animate = () => {
      this.raf = requestAnimationFrame(animate);

      const delta = clock.getDelta()
      this.update(delta)

      renderer.render(scene, camera);
    }

    animate()
  }

  update (delta) {
    let sp = this.smokeParticles.length;
    while (sp--) {
      this.smokeParticles[sp].rotation.z += (delta * 0.2);
    }
  }

  componentDidMount() {
    this.init()
  }

  render () {
    const { progress } = this.props

    if (progress === 100) {
      cancelAnimationFrame(this.raf)
    }

    return (
      <div className={styles.wrap} style={{
        display: progress === 100 ? 'none' : 'block'
      }}>
        <canvas ref={this.ref}></canvas>
        <Progress percent={progress}></Progress>
      </div>
    )
  }
}
